import Auth from '@/helpers/authorizations'
import Management from '@/layouts/Management'

export default {
  path: '/advertisement_click_records',
  component: Management,
  redirect: '/advertisement_click_records/list',
  children: [
    // 列表页
    {
      path: 'list',
      component: () => import('@/views/advertisement_click_records/List'),
      redirect: 'list/all',
      meta: {
        auth: Auth.showAdvertisement
      },
      children: [
        {
          path: 'all',
          component: () => import('@/views/advertisement_click_records/ListTable'),
          meta: {
            auth: Auth.showAdvertisement,
            tabName: 'all'
          }
        }
      ]
    }
  ]
}
